import { CarouselState } from "../models/CarouselState.model";

export const initialState = (slidesLength: number): CarouselState => ({
  slidesLength,
  takeFocus: false,
  isPlaying: true,
  currentIndex: 0
});
